function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { hasOwnProperty, isArray } from 'vega-util';
import { hasConditionalFieldOrDatumDef, isConditionalDef, isFieldDef, isFieldOrDatumDef, isRepeatRef, isSortableFieldDef } from '../channeldef';
import * as log from '../log';
import { isSortField } from '../sort';
import { isFacetMapping } from '../spec/facet';
export function replaceRepeaterInFacet(facet, repeater) {
  if (!repeater) {
    return facet;
  }

  if (isFacetMapping(facet)) {
    return replaceRepeaterInMapping(facet, repeater);
  }

  return replaceRepeaterInFieldDef(facet, repeater);
}
export function replaceRepeaterInEncoding(encoding, repeater) {
  if (!repeater) {
    return encoding;
  }

  return replaceRepeaterInMapping(encoding, repeater);
}
/**
 * Replaces repeated value and returns if the repeated value is valid.
 */

function replaceRepeatInProp(prop, o, repeater) {
  var val = o[prop];

  if (isRepeatRef(val)) {
    if (val.repeat in repeater) {
      return _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, prop, repeater[val.repeat]));
    } else {
      log.warn(log.message.noSuchRepeatedValue(val.repeat));
      return undefined;
    }
  }

  return o;
}
/**
 * Replace repeater values in a field def with the concrete field name.
 */


function replaceRepeaterInFieldDef(fieldDef, repeater) {
  fieldDef = replaceRepeatInProp('field', fieldDef, repeater);

  if (fieldDef === undefined) {
    // the field def should be ignored
    return undefined;
  } else if (fieldDef === null) {
    return null;
  }

  if (isSortableFieldDef(fieldDef) && isSortField(fieldDef.sort)) {
    var sort = replaceRepeatInProp('field', fieldDef.sort, repeater);
    fieldDef = _objectSpread(_objectSpread({}, fieldDef), sort ? {
      sort: sort
    } : {});
  }

  return fieldDef;
}

function replaceRepeaterInFieldOrDatumDef(def, repeater) {
  if (isFieldDef(def)) {
    return replaceRepeaterInFieldDef(def, repeater);
  } else {
    var datumDef = replaceRepeatInProp('datum', def, repeater);

    if (datumDef !== def && !datumDef.type) {
      datumDef.type = 'nominal';
    }

    return datumDef;
  }
}

function replaceRepeaterInChannelDef(channelDef, repeater) {
  if (isFieldOrDatumDef(channelDef)) {
    var fd = replaceRepeaterInFieldOrDatumDef(channelDef, repeater);

    if (fd) {
      return fd;
    } else if (isConditionalDef(channelDef)) {
      return {
        condition: channelDef.condition
      };
    }
  } else {
    if (hasConditionalFieldOrDatumDef(channelDef)) {
      var _fd = replaceRepeaterInFieldOrDatumDef(channelDef.condition, repeater);

      if (_fd) {
        return _objectSpread(_objectSpread({}, channelDef), {}, {
          condition: _fd
        });
      } else {
        var condition = channelDef.condition,
            channelDefWithoutCondition = _objectWithoutProperties(channelDef, ["condition"]);

        return channelDefWithoutCondition;
      }
    }

    return channelDef;
  }

  return undefined;
}

function replaceRepeaterInMapping(mapping, repeater) {
  var out = {};

  for (var channel in mapping) {
    if (hasOwnProperty(mapping, channel)) {
      var channelDef = mapping[channel];

      if (isArray(channelDef)) {
        // array cannot have condition
        out[channel] = channelDef // somehow we need to cast it here
        .map(function (cd) {
          return replaceRepeaterInChannelDef(cd, repeater);
        }).filter(function (cd) {
          return cd;
        });
      } else {
        var cd = replaceRepeaterInChannelDef(channelDef, repeater);

        if (cd !== undefined) {
          out[channel] = cd;
        }
      }
    }
  }

  return out;
}